import { PrivilegiosService } from 'app/servicios/privilegios.service';
import { Privilegios } from 'app/entidades/entidades';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../servicios';
import { ConfigService } from '../servicios/config.service';
import { Config } from '../entidades/entidades';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    private redirected = false;
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private privilegiosService: PrivilegiosService,
        private configService: ConfigService
    ) { }
    config: Config;
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        //valida, si la confiracion esta en el localstorage, si no, la obtiene del servicio y la guarda en el localstorage.
        if (this.config === undefined) 
        {
            this.config = await this.configService.getBaseUrlApiWeb();
            console.log('this.config', this.config);
            let configJson = JSON.stringify(this.config);
            localStorage.setItem('config', configJson);
        }

        
        //valida, si la ruta va a el pago en linea, lo redirige a la pagina de pago en linea.
        if (state.url == "/estadocuentaonline" 
        || /^\/estadocuentaonline\/\d+/.test( state.url)
        ||   /^\/estadocuentaonline\?(&?[a-zA-Z0-9_]+=[a-zA-Z0-9%.+:@-]+)+$/.test(state.url)
        || (state.url.length >= 19 && state.url.substring(1, 19) === 'estadocuentaonline') ||
           (state.url.length >= 20 && state.url.substring(22, 42) === 'estadocuentaonline/?') || 
           (state.url.length >= 20 && state.url.substring(1, 20) === 'estadocuentaonline?') 
        ){
            
            if (!this.redirected) 
            {
                 this.router.navigateByUrl(state.url.replace(/^\/dashboard\/dashboard#/, ""), { skipLocationChange: true });
                 this.redirected = true;
            }
            

         return true;
        }

         const config = JSON.parse(localStorage.getItem('config')); // si la configuracion es de pago en linea, lo redirige a la pagina de pago en linea.
        if (config.flagPagoEnlinea) 
        {
            this.router.navigateByUrl('estadocuentaonline', { skipLocationChange: true });
            return true;
        }


        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) 
        {
            //si ya esta logeado, el usuario, si es dashboard o el pagoenlinea, lo deja pasar.
            if (state.url === '/dashboard/dashboard') 
                return true;
        
            //si es otra ruta, verifica si tiene privilegios
            let objUrl = new Privilegios();
            objUrl.descripcion = state.url;
            let result: Privilegios = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
            if (result)
                return true;
            else
                return false;
        }
        //si no esta logeado, lo redirige al login.
        this.router.navigateByUrl('login', { skipLocationChange: true });
        return false;
    }
}